import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133eec6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchlist" }
const _hoisted_2 = {
  key: 0,
  class: "history"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "历史搜索", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["searchStockSelectwrap", _ctx.theme]),
    style: {"{'padding-right'":"'140px'}"},
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlefocusInput && _ctx.handlefocusInput(...args)))
  }, [
    _createVNode(_component_a_input_search, {
      ref: "askingselect",
      placeholder: _ctx.placeholder,
      autocomplete: "off",
      id: "askingInput",
      allowClear: true,
      value: _ctx.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      onFocus: _ctx.focusSelect,
      onBlur: _ctx.blurSelect,
      onKeyup: _ctx.inputKeyup,
      onChange: _ctx.searchValue
    }, null, 8, ["placeholder", "value", "onFocus", "onBlur", "onKeyup", "onChange"]),
    _withDirectives(_createElementVNode("section", _hoisted_1, [
      _createElementVNode("ul", {
        onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlekeyFn($event)))
      }, [
        (_ctx.searchstr === '' && (_ctx.historyOption||[]).length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearHistory && _ctx.clearHistory(...args)))
              }, [
                _createVNode(_component_DeleteOutlined)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOption, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.Id,
            class: _normalizeClass({'active': _ctx.activeLi === item.Id}),
            onClick: ($event: any) => (_ctx.handleChange($event, item))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.Code), 1),
            _createElementVNode("span", {
              title: item.Name
            }, _toDisplayString(item.Name), 9, _hoisted_5),
            _createElementVNode("span", null, _toDisplayString(item.MarketCode==='sh' ? '沪A' : item.MarketCode==='sz' ? '深A' : ''), 1)
          ], 10, _hoisted_4))
        }), 128))
      ], 32)
    ], 512), [
      [_vShow, _ctx.selectOption.length && _ctx.showDropdown]
    ])
  ], 2))
}